import axios from 'axios'

const { REACT_APP_API_GATEWAY } = process.env

export const renewAuth = (transactionId: string) => {
  const url = `${REACT_APP_API_GATEWAY}/auth/${transactionId}/renew`
  return axios.post(url, {})
}
